import Head from 'next/head'

type OGPProps = {
  title: string
  description: string
  url: string
  imgUrl: string
  imgWidth: string | number
  imgHeight: string | number
}

export const OGP = ({
  title,
  description,
  url,
  imgUrl,
  imgWidth,
  imgHeight,
}: OGPProps) => {
  return (
    <Head>
      <title>{title}</title>
      <meta name="viewport" content="width=device-width,initial-scale=1.0" />
      <meta name="description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:site_name" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={imgUrl} />
      <meta property="og:image:width" content={String(imgWidth)} />
      <meta property="og:image:height" content={String(imgHeight)} />

      {/* Twitterの設定 */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={url} />
      <meta name="twitter:image" content={imgUrl} />
      <meta name="twitter:image:alt" content={title} />
      <meta name="twitter:title" content="BUMP" />
    </Head>
  )
}
